// import "./WorkCardStyles.css";
// import { WorkCardData } from "./WorkCardData";
// import { WorkCard } from "./WorkCard";

// import React from "react";

// export const Work = () => {
//   return (
//     <div className="work-container">
//       <div className="project-heading">
//         <div className="project-container">

//       {WorkCardData.map((val, ind) => {
//           return(
//             <WorkCard 
//             key={ind}
//             imgsrc = {val.imgsrc}
//             title = {val.title}
//             text = {val.text}
//             view  = {val.view}
//             />
//           )
//       }
//       )
//       }

//         </div>
//       </div>
//     </div>
//   );
// };
import "./WorkCardStyles.css";
import { WorkCardData } from "./WorkCardData";
import { WorkCard } from "./WorkCard";
import React from "react";

export const Work = () => {
  const containerClassName =
    WorkCardData.length <= 2 ? "project-container-centered" : "project-container";

  return (
    <div className="work-container">
      <div className="project-heading">
        <div className={containerClassName}>
          {WorkCardData.map((val, ind) => (
            <WorkCard
              key={ind}
              imgsrc={val.imgsrc}
              title={val.title}
              text={val.text}

            />
          ))}
        </div>
      </div>
    </div>
  );
};
